import { Brush } from './brush';

export class Eraser extends Brush {
  constructor(
    mainCtx: CanvasRenderingContext2D,
    animCtx: CanvasRenderingContext2D,
    updateState: () => void
  ) {
    super(mainCtx, animCtx, updateState);
    mainCtx.globalCompositeOperation = 'destination-out';
  }

  setColor(color: string): void {
    super.setColor(color);
    this.mainCtx.globalCompositeOperation = 'destination-out';
  }

  protected drawDot(e: MouseEvent | TouchEvent): void {
    const { x, y } = this.getMousePosition(e);
    this.mainCtx.arc(x, y, 1, 0, 2 * Math.PI);
    this.mainCtx.stroke();
  }
}
